"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoxNumber = void 0;
const utils_1 = require("./utils");
const internalRoxNumber = utils_1.internalRox.RoxNumber;
class RoxNumber extends internalRoxNumber {
}
exports.RoxNumber = RoxNumber;
//# sourceMappingURL=number.js.map